var _style, _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddMembreCoverDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1377.9 274.6",
    style: {
      enableBackground: "new 0 0 1377.9 274.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#212529;}\r\n\t.st2{fill:#505153;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "addMembreCoverDarkArtboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M0,0h1377.9v272.6c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -45.6,
    y: -58.7,
    className: "st1",
    width: 1463,
    height: 346.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 687.9,
    cy: 346.7,
    r: 615.4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M469.6,212.5l5.4-10.6c5.8,3.7,14.3,6.3,22.5,6.3c9.4,0,13.2-2.8,13.2-6.5c0-11.4-39.7-3.6-39.7-26.1 c0-10.3,9.4-18.9,28.8-18.9c8.6,0,17.4,1.8,23.7,5.4l-4.9,10.7c-5.9-3-12.3-4.7-18.9-4.8c-9.4,0-13,3.1-13,7 c0,11.2,39.7,3.5,39.7,25.8c0,10.2-9.5,18.8-29,18.8C486.6,219.5,475.7,216.6,469.6,212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M537.2,157.7H553v60.8h-15.8V157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M612.7,218.5l-13.2-16.9H585v16.9h-15.8v-60.8h29.6c18.2,0,29.7,8.4,29.7,22c0,9.1-5.2,15.8-14,19.2l15.3,19.5 L612.7,218.5z M597.9,169.1H585v21.2h12.9c9.7,0,14.5-4,14.5-10.6C612.4,173.1,607.6,169.1,597.9,169.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M672.7,196.9v21.5h-15.8v-21.7l-26.4-39.1h16.8l18.2,27l18.2-27h15.5L672.7,196.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M701.8,188.1c0-18.3,15.8-31.4,37.1-31.4c11.8,0,21.7,3.8,28.1,10.8l-10.1,8.3c-4.5-4.7-10.7-7.3-17.2-7.1 c-12.8,0-21.8,8-21.8,19.4c0,11.5,9.1,19.4,21.9,19.4c6.5,0.1,12.7-2.5,17.1-7.2l10.1,8.3c-6.4,7-16.3,10.8-28.2,10.8 C717.6,219.5,701.8,206.4,701.8,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M820.4,205.4h-31.7l-6,13h-16.2l30.4-60.8h15.6l30.5,60.8h-16.6L820.4,205.4z M815.4,194.8l-10.8-23.2 l-10.8,23.2H815.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M891.3,218.5l-13.2-16.9h-14.5v16.9h-15.8v-60.8h29.6c18.2,0,29.7,8.4,29.7,22c0,9.1-5.2,15.8-14,19.2 l15.3,19.5L891.3,218.5z M876.5,169.1h-12.9v21.2h12.9c9.7,0,14.5-4,14.5-10.6C891,173.1,886.1,169.1,876.5,169.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M889.4,102.6c0,0-8.7-22.6-20.7-32.2c0,0-22.6,8.2-98.1-9.1s-126,5.8-145.7,20.2c0,0,50-28.9,105.3-20.7 c55.3,8.2,97.2,21.7,136.1,16.4C866.3,77.1,883.1,89.1,889.4,102.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M741.2,89.1L767.7,79c0,0-44.3-25.5-121.7-3.9c0,0,57.9-29.3,132.9,2.7C778.9,77.9,774.7,82,741.2,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M675.7,117c0,0,36.6,10.9,96.8-21.5c60.3-32.4,101-4.5,101-4.5s19.2,13.7,21.6,45.9c0,0-5.6-57.5-67.5-51.7 S737.2,135.3,675.7,117z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M742,96.5c0,0-48.9,18.1-129.2-5s-123.6,9.6-132.7,15.9c0,0,2.4,20.7,12,33.7c0,0-7.2-19.9-4.6-32.1 c0,0,41.7-26.3,84.6-19.6c43,6.8,66.4,12.2,74.7,13.5S694.9,112.8,742,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M742.8,95.7c0,0-48.9,18.1-129.2-5s-123.6,9.6-132.7,15.9c0,0,2.4,20.7,12,33.7c0,0-7.2-19.9-4.6-32.1 c0,0,41.7-26.3,84.6-19.6c43,6.8,66.4,12.2,74.7,13.5C655.9,103.4,695.7,112,742.8,95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M680.6,146.5c0,0-20.2,5.1-75.7-31.7c0,0-21.5-15.7-41.4-20.2s-61.6,5.4-49.7,48.1c0,0-4.8-47.8,43.9-44.3 c0,0,19.6,2.6,51.6,24.1C641.5,143.9,655.9,144.2,680.6,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M603.4,126.9c0,0,17.7,13.8,21.5,14.1c0,0-13.5-2.9-19.2-7.7c0,0,0,6.7-9.9,13.5 C595.7,146.8,603.7,137.8,603.4,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M706.1,146.5c0,0,20.2,5.1,75.7-31.7c0,0,21.5-15.7,41.4-20.2s61.6,5.4,49.7,48.1c0,0,4.8-47.8-43.9-44.3 c0,0-19.6,2.6-51.6,24.1C745.2,143.9,730.8,144.2,706.1,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M787.2,126.9c0,0-17.6,13.8-21.4,14.1c0,0,13.5-2.9,19.2-7.7c0,0,0,6.7,9.9,13.5 C794.9,146.8,786.9,137.8,787.2,126.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMembreCoverDark);
export default __webpack_public_path__ + "static/media/addMembreCoverDark.8d2cb08c38b8d4c1b6237dfba28c0b92.svg";
export { ForwardRef as ReactComponent };